import React from "react"
import NotificationSettingsForm from "src/features/notifications/components/NotificationSettingsForm"

export default function NotificationSettingsPage() {
  return <NotificationSettingsForm />
}
